import result from 'lodash/result'
import RA from 'ra-config'
import { rafiSiteUrl } from 'lib/config/url'
//import * as learnMoreLink from 'lib/config/learn-more'

const STRATEGY_DESCRIPTIONS = RA.content.strategies.descriptions
const FACTOR_DESCRIPTIONS = RA.content.factors.descriptions

/**
 * Generates a strategy description including its learn more link.
 *
 * @export
 * @param {any} name
 * @param {any} category
 * @param {any} region
 * @returns {String}
 */
export function descriptionForStrategy(name, category, region) {
  const description = result(STRATEGY_DESCRIPTIONS, [name, region], '')

  let link = result(STRATEGY_DESCRIPTIONS, [name, 'learnMoreLink'])
  if (link) {
    link = `<a href="${rafiSiteUrl(link)}" target="_blank">Learn More</a>`
  } else {
    link = ''
  }

  return description + ' ' + link
}

/**
 * Generates a factor description including its learn more link.
 *
 * @export
 * @param {any} name
 * @param {any} category
 * @param {any} region
 * @returns {String}
 */
export function descriptionForFactor(name, category, region) {
  const description = result(FACTOR_DESCRIPTIONS, [name, category, region], '')
  //const link = learnMoreLink.forFactor()

  return description
}



// WEBPACK FOOTER //
// ./src/config/description.js